import hierarchyApi from 'Agent/AgentInformation/api/hierarchyApi';
import {changeHierarchy, getHierarchyByAgentNumber, HierarchyActionType} from 'Agent/AgentInformation/ducks/hierarchy';
import {AgentHierarchy} from 'Agent/AgentInformation/models/AgentHierarchy';
import {AsyncResult, fromResult, Loading} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import {all, call, put, takeLatest} from 'redux-saga/effects';

function* getHierarchyByAgentNumberSaga() {
  yield takeLatest(HierarchyActionType.GET_HIERARCHY_BY_AGENT_NUMBER, function*(
    action: ReturnType<typeof getHierarchyByAgentNumber>
  ) {
    const {
      agentNumber,
      agencyFilters: {isNewYork, encryptedIdentifier},
    } = action.payload;
    yield put(changeHierarchy(new Loading()));

    const result: AsyncResult<AgentHierarchy> = yield call(
      hierarchyApi.getHierarchyByAgentNumber,
      agentNumber,
      isNewYork,
      encryptedIdentifier
    );

    const changeAction = pipe(result, E.map(fromResult), E.fold(changeHierarchy, changeHierarchy));

    yield put(changeAction);
  });
}

export default function*() {
  yield all([getHierarchyByAgentNumberSaga()]);
}
